module.exports = __webpack_public_path__ + "img/icon-chevron-up.1ad208a4.svg";